import React, { useState, useRef } from "react";
import gsap from "gsap";
import {
  Stack, ListGroup
} from "react-bootstrap";
import { NavLink, useLocation } from 'react-router-dom';

const HeaderSubMenus = (props) => {
  let { pathname, state } = useLocation();
  let scrlmenu = useRef(props.scrlmenu);
  let scrl = scrlmenu;
  const [scrollX, setscrollX] = useState(0);
  const [scrolEnd, setscrolEnd] = useState(false);

  const [overflowTabMenu, setOverflowTabMenu] = React.useState(false);

  React.useLayoutEffect(() => {
    if (scrl.current.clientWidth < scrl.current.scrollWidth) {
      setOverflowTabMenu(true);
    }
  }, [scrlmenu]);

  //Slide click
  const slide = (shift) => {
    scrl.current.scrollLeft += shift;
    setscrollX(scrollX + shift);

    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };



  //Anim
  const anim = (e) => {
    gsap.from(e.target, { scale: 1 });
    gsap.to(e.target, { scale: 1.5 });
  };
  const anim2 = (e) => {
    gsap.from(e.target, { scale: 1.5 });
    gsap.to(e.target, { scale: 1 });
  };

  const scrollCheck = () => {
    setscrollX(scrl.current.scrollLeft);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  // console.log("props", props.childmenus.SubMenu);


  return (
    <div>
      {scrollX !== 0 && (
        <button
          className="tabmenu-prev"
          onClick={() => slide(-200)}
          onMouseEnter={(e) => anim(e)}
          onMouseLeave={(e) => anim2(e)}
        >
          <i className="fa-solid fa-angle-left"></i>
        </button>
      )}
      <Stack direction="horizontal" className={overflowTabMenu ? "header-tab-menus overlow-tabmenu" : "header-tab-menus"} gap={1} ref={scrl} onScroll={scrollCheck}>


        {props.childmenus.SubMenu.map((menu, i) => {
          const isActive = pathname.indexOf(`/${menu.ParentId.toLowerCase()}/${menu.MenuId.toLowerCase()}`) !== -1;
          return (
            <NavLink
              to={`/admin/${menu.ParentId.toLowerCase()}/${menu.MenuId.toLowerCase()}${menu.HasSubMenu ? `/${menu.SubMenu[0].MenuId.toLowerCase()}` : ''}`}
              key={'sidemenu-' + menu.ParentId + menu.MenuId}
              className={"item headersubmenuactive " + (pathname.indexOf(`/${menu.ParentId.toLowerCase()}/${menu.MenuId.toLowerCase()}`)!='-1' ? 'active':'')}
            >
              {menu.Name}
            </NavLink>
          );
        })}

      </Stack>
      {(
        <button
          className="tabmenu-next"
          onClick={() => slide(+200)}
          onMouseEnter={(e) => anim(e)}
          onMouseLeave={(e) => anim2(e)}
        >
          <i className="fa-solid fa-angle-right"></i>
        </button>
      )}
    </div>

  );
}

export default HeaderSubMenus;